import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import type { ITableEditableCell } from '../types';

const TableEditableCell = ({ defaultValue, isEditable, onChange }: ITableEditableCell): React.ReactElement => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const onBlur = () => {
    onChange(value);
  };

  return <TableCellInput value={value} onChange={handleChange} onBlur={onBlur} disabled={!isEditable} />;
};

export { TableEditableCell };

const TableCellInput = styled.input`
  height: 28px;
  margin: 2px;
  padding-left: 8px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  background-color: #fff;
  width: calc(100% - 2px);

  &:disabled {
    border: none;
    margin-left: 0;
    padding-left: 0;
  }
`;
